export default __webpack_public_path__ + "static/ewallet-for-toll-road-payment-solutions-7f559b9cb89d902b5b3805064ee7a053.png";